import { environmentHttpClient } from "client/Api/httpClient";
import { UserIdentityModel } from "../UserProfile/service";
import { CommunityViewModel } from "./communityPosts";

export type CommunityMembershipRequestListItem = {
	id: number;
	requestedBy: UserIdentityModel;
	community: CommunityViewModel;
	requestedOn: Date | string;
};

export function listMembershipRequests(
	signal?: AbortSignal
): Promise<readonly CommunityMembershipRequestListItem[]> {
	return environmentHttpClient.get<readonly CommunityMembershipRequestListItem[]>(
		"/UiApi/Communities/MembershipRequests",
		undefined,
		{ signal }
	);
}

export function approveMembershipRequest(id: number, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		`/UiApi/Communities/MembershipRequests/${id}/Approve`,
		undefined,
		{ signal }
	);
}

export function declineMembershipRequest(id: number, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		`/UiApi/Communities/MembershipRequests/${id}/Decline`,
		undefined,
		{ signal }
	);
}
